import { Instance, types } from "mobx-state-tree";

import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";

export const RequiredUniqueDropdownOptionsProperties = types.model({
  areOptionsRequired: types.boolean,
  areOptionsUnique: types.boolean,
});

export const CustomDropdownOptionsValidatorModel = types
  .compose(ValidatorModel, RequiredUniqueDropdownOptionsProperties)
  .actions((self) => {
    const optionsAreDuplicated = (value: string) => {
      const options = value.split("\n");
      const validOptions: string[] = options.reduce(function (result: any, option: string) {
        if (option && option.trim()) return [...result, option.trim().toLowerCase()];
        return result;
      }, []);
      const duplicates = validOptions.filter((item, index) => validOptions.indexOf(item) !== index);
      return duplicates.length !== 0;
    };

    return {
      validate(value: string) {
        if (self.areOptionsRequired && (!value || !value.trim())) {
          return ValidationMesssageModel.create({
            message: { mainKey: "general.validation.required" },
          });
        }
        if (self.areOptionsUnique && optionsAreDuplicated(value)) {
          return ValidationMesssageModel.create({
            message: {
              mainKey: "general.validation.dropdown-options.notUnique",
            },
          });
        }
        return undefined;
      },
    };
  });
export type DropdownOptionsValidator = Instance<typeof CustomDropdownOptionsValidatorModel>;
